import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { AUTHORIZATION_ERROR_CODES } from "../constants/errorCodes";

export interface AuthorizationErrorOptions {
  message: string;
  resource?: string;
  action?: string;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown when authorization fails
 */
export class AuthorizationError extends BaseError {
  public readonly resource?: string;
  public readonly action?: string;

  constructor(options: AuthorizationErrorOptions) {
    super({
      message: options.message,
      category: "authorization",
      severity: "medium",
      statusCode: 403,
      code: options.code ?? AUTHORIZATION_ERROR_CODES.AUTHORIZATION_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: true,
      reportable: true,
    });

    this.resource = options.resource;
    this.action = options.action;
  }
}
